import React, {useContext, useState, useEffect} from 'react';
import Dashview from 'paths/admin/dashboard/Dashview';
import axios from 'axios';
import {AppContext} from 'AppContext';
import {useParams} from "react-router-dom";
import ApxEditAddress from "comps/ApxEditAddress";


const Content = (props) => {
    // Need the account id from the URL parameters:
    const params = useParams();
    // Need the user's identity and global application config:
    const { config } = useContext(AppContext);

    const [success, set_success] = useState(false);
    const [account, set_account] = useState(null);
    const [pricing, set_pricing] = useState([]);
    const [addresses, set_addresses] = useState(null);
    const [show_new_addr_modal, set_show_new_addr_modal] = useState(false);
    const [modal_addr, set_modal_addr] = useState(null);
    const [modal_err, set_modal_err] = useState(false);
    
    // Retrieve relevant records for this account:
    useEffect(() => {
        const action = async () => {
            const account_api_response = await axios.get(config.api.base + '/admin/accounts/' + params.id);
            set_account(account_api_response.data[0]);
            const pricing_api_response = await axios.get(config.api.base + '/pricing/tables');
            set_pricing(pricing_api_response.data);
            const addresses_api_response = await axios.get(config.api.base + '/addresses/account/' + params.id);
            set_addresses(addresses_api_response.data);
        }
        action();
    }, [config.api.base, params.id])

    function onChangeFirstName(args) {
        set_success(false);
        account.first_name = args.target.value;
        set_account({...account})
    }

    function onChangeLastName(args) {
        set_success(false);
        account.last_name = args.target.value;
        set_account({...account})
    }

    function onChangeCompany(args) {
        set_success(false);
        account.company = args.target.value;
        set_account({ ...account})
    }

    function onChangeEmail(args) {
        set_success(false);
        account.email = args.target.value;
        set_account({...account})
    }

    function onChangePhone(args) {
        set_success(false);
        account.phone = args.target.value;
        set_account({...account})
    }

    function onChangePriceTable(args) {
        set_success(false);
        account.pricing_id = args.target.value;
        set_account({ ...account})
    }

    function onChangeCheckedAcctInfo(acct, field) {
        return (args) => {
            set_success(false);
            acct[field] = args.target.checked;
            set_account({...acct});
        }
    }

    function onDeleteAddr(selected_addr) {
        return (args) => {
            const action = async () => {
                try {
                    if (addresses[selected_addr].default && addresses.length > 1) {
                        const new_default = selected_addr === 0 ? 1 : 0;
                        await axios.put(config.api.base + '/addresses/' + addresses[new_default].id, {...addresses[new_default], default: true})
                    }
                    
                    const response = await axios.delete(config.api.base + '/addresses/' + addresses[selected_addr].id);
                    console.log(response);

                    const action = async () => {
                        const address_api_response = await axios.get(config.api.base + '/addresses/account/' + params.id);
                        set_addresses(address_api_response.data);
                    }
                    action();
                } catch (e) {}
            }
            action()
        }
    }

    
    function onEditAddr(selected_addr) {
        return (args) => {
            set_modal_addr(addresses[selected_addr]);
            set_show_new_addr_modal(true);
        }
    }
    
    function onAddNewAddr(_) {
        set_modal_addr(null);
        set_show_new_addr_modal(true);
    }

    function onCancelNewAddr() {
        set_show_new_addr_modal(false);
        set_modal_err(false);
    }
    
    function onSaveNewAddr(new_addr) {
        set_modal_err(false);
        const action = async () => {
            try {
                new_addr.acctId = params.id;

                if (addresses.length === 0) {
                    new_addr.default = true;
                }

                if (new_addr.default) { 
                    const old_default_addr_index = addresses.findIndex((addr) => addr.default);
                    if (old_default_addr_index !== -1) {
                        const old_default_addr = { ...addresses[old_default_addr_index], default: false};
                        await axios.put(config.api.base + '/addresses/' + old_default_addr.id, old_default_addr);
                    }
                }

                const response = await axios.post(config.api.base + '/addresses', new_addr)
                console.log(response);

                const action = async () => {
                    const address_api_response = await axios.get(config.api.base + '/addresses/account/' + params.id);
                    set_addresses(address_api_response.data);
                }
                action();

                set_modal_addr(null); 
                set_show_new_addr_modal(false);

            } catch (e) {
                console.log(e);
                set_modal_err(true);
            }
        }
        action();
    }

    function onSaveEditAddr(edited_addr) {
        set_modal_err(false);
        const action = async () => {
            try {
                const delete_old = await axios.delete(config.api.base + '/addresses/' + edited_addr.id);
                console.log(delete_old);

                const response = await axios.post(config.api.base + '/addresses', edited_addr);
                console.log(response);

                const action = async () => {
                    const address_api_response = await axios.get(config.api.base + '/addresses/account/' + params.id);
                    set_addresses(address_api_response.data);
                }
                action();

                set_modal_addr(null);
                set_show_new_addr_modal(false);

            } catch (e) {
                console.log(e);
                set_modal_err(true);
            }
        }
        action();
    }

    function changeDefaultAddr(selected_addr) {
        const action = async () => {
            try {
                const old_default_addr_index = addresses.findIndex((addr) => addr.default);
                if (old_default_addr_index !== -1) {
                    const old_default_addr = { ...addresses[old_default_addr_index], default: false};
                    await axios.put(config.api.base + '/addresses/' + old_default_addr.id, old_default_addr);
                }

                const response = await axios.put(config.api.base + '/addresses/' + addresses[selected_addr].id, {...addresses[selected_addr], ...{default: true}})
                console.log(response);
                
                const action = async () => {
                    const address_api_response = await axios.get(config.api.base + '/addresses/account/' + params.id);
                    set_addresses(address_api_response.data);
                }
                action();

            } catch (e) {
                console.log(e);
            }
        }
        action();
    }

    function onSubmit(args) {
        set_success(false);
        args.preventDefault();
        const action = async () => {
            try {
                account.card_payment = account.card_payment ?? false;
                account.tax_exempt = account.tax_exempt ?? false;
                account.fob = account.fob ?? false;
                set_account({...account});

                const response = await axios.put(config.api.base + '/admin/accounts/' + params.id, account);
                console.log(response);
                set_success(true);
            } catch (x) {

            }
        }
        action();
    }

    if(account === null || addresses === null) {
        return null;
    }

    return(
        <div className={"container sm:w-4/5 mx-auto mt-8"}>
            <div className="w-full">
                <form onSubmit={onSubmit}>
                    <div className="flex justify-between align-center my-8">
                        <h2 className={"text-3xl font-extrabold text-gray-900"}>
                            Edit Account:&nbsp;
                            <span className={"font-normal text-3xl text-gray-500"}>
                                {params.id}
                            </span>
                        </h2>
                    </div>
                    { (account.card_payment === null || account.tax_exempt === null || account.fob === null) &&
                        <div className="errorBox mb-8">
                            Account setup has not been finalized. Please confirm all Payment Settings below to finish activating the account.
                        </div>
                    }
                    <div className={"flex flex-wrap"}>
                    <div className={"w-2/4 border-r-2 pr-4 space-y-4 border-dashed"}>
                        <div className={"w-full"}>
                            <h3 className="text-xl font-semibold text-gray-900">User Information</h3>
                        </div>
                        <div className={"flex space-x-6"}>
                            <div className={"w-full"}>
                                <label htmlFor="first-name">First name</label>
                                <input id="first-name" name="firstName" error={"true"}  type="text" autoComplete="given-name"
                                    value={account.first_name} required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                    placeholder="First name"
                                    onChange={onChangeFirstName}
                                />
                            </div>
                            <div className={"w-full"}>
                                <label htmlFor="last-name">Last name</label>
                                <input id="last-name" name="lastName" type="text" autoComplete="family-name" required
                                    value={account.last_name}
                                    onChange={onChangeLastName}
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                    placeholder="Last name"/>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="company">Company</label>
                            <input id="company" name="company" type="text" autoComplete="company"
                                required
                                value={account.company}
                                onChange={onChangeCompany}
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Company"/>
                        </div>
                        <div>
                            <label htmlFor="email">Email address</label>
                            <input id="email" name="email" type="email" autoComplete="email"
                                required
                                value={account.email}
                                onChange={onChangeEmail}
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Email"/>
                        </div>
                        <div>
                            <label htmlFor="phone">Phone number</label>
                            <input id="phone" name="email" type="text" autoComplete="phone"
                                required
                                value={account.phone}
                                onChange={onChangePhone}
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Phone number"/>
                        </div>
                        <div className={"w-full"}>
                            <div>
                                <label htmlFor="price_table">
                                    Pricing Table
                                </label>
                                <select
                                    id="price_table"
                                    name="price_table"
                                    autoComplete="price_table"
                                    value={account.pricing_id}
                                    onChange={onChangePriceTable}
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                    {pricing.map((item, index) => {
                                        return <option key={index} value={item.id}>{item.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"flex flex-col flex-wrap border-t-2 mt-6 pt-2 border-dashed xl:flex-row"}> 
                            <div className="w-full pb-4">
                                <h3 className="text-xl font-semibold text-gray-900">Payment Settings</h3>
                            </div>
                            <div className="w-full xl:w-1/3">
                                <input id="card-payment" name="card-payment" type="checkbox" checked={account.card_payment} onChange={onChangeCheckedAcctInfo(account, "card_payment")}/>
                                <label htmlFor="card-payment" className="pl-2">Credit Card</label>
                            </div>
                            <div className="w-full xl:w-1/3">
                                <input id="tax-exempt" name="tax-exempt" type="checkbox" disabled={!account.card_payment} checked={account.tax_exempt} onChange={onChangeCheckedAcctInfo(account, "tax_exempt")}/>
                                <label htmlFor="tax-exempt" className={account.card_payment ? "pl-2" : "text-gray-600 pl-2"}>Tax Exempt</label>
                            </div>
                            <div className="w-full xl:w-1/3">
                                <input id="fob" name="fob" type="checkbox" checked={account.fob} onChange={onChangeCheckedAcctInfo(account, "fob")}/>
                                <label htmlFor="fob" className="pl-2">FoB 3rd Party</label>
                            </div>
                            { !account.card_payment &&
                                <div className="w-full pt-2">
                                    <p className="text-gray-700 italic">*Net 30 customers will not have tax calculated through the portal</p>
                                </div>
                            }
                        </div>
                        <div className="flex mt-8 items-center">
                            <button type={"submit"} className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Save Changes
                            </button>
                            { success &&
                                <p className="pl-4 text-lg"> 
                                    Saved!
                                </p>
                            }
                        </div>
                    </div>
                    <div className={"w-2/4 space-y-4 pl-4"}>
                        <div className={"w-full"}>
                            <h3 className="text-xl font-semibold text-gray-900">Address Information</h3>
                            <p className="italic text-gray-900">*Address changes are saved automatically</p>
                        </div>
                        {addresses.length > 0 ?
                            addresses.map((item, index) => {
                                const default_line = item.default ? "[Default]\n" : "";
                                const city_state_line = item.city + ", " + item.state + " " + item.zip;
                                const address_block = [item.name, item.org, item.address_1, item.address_2, city_state_line, item.country].filter(Boolean).join("\n");
                                return <div className={"w-full flex items-center justify-between border-b pb-2 border-dashed border-gray-500"}>
                                    <div className={"whitespace-pre"}>
                                        <span className="font-medium">{default_line}</span>{address_block}
                                    </div>
                                    <div className={"flex items-center space-x-2"}>
                                        { default_line === "" &&
                                        <div>
                                            <button type="button" onClick={() => changeDefaultAddr(index)} className="justify-center rounded-md border border-transparent shadow-sm px-2 py-1 text-base text-gray-800 bg-gray-300 hover:bg-gray-400  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 ">
                                                Make Default
                                            </button>
                                        </div>
                                        }
                                        <div>
                                            <button type="button" onClick={onEditAddr(index)} className="justify-center rounded-md border border-transparent shadow-sm px-2 py-1 text-base text-gray-800 bg-gray-300 hover:bg-gray-400  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 ">
                                                Edit Address
                                            </button>
                                        </div>
                                        <div>
                                            <button type="button" onClick={onDeleteAddr(index)} className="justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-500 opacity-80 text-base text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ">
                                                Delete Address
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            })
                            :
                            <div className={"w-full"}>No address information found. Please add a new address.</div>
                        }
                        <div className={"w-full"}>
                            <div>
                                <button type="button" className="standardButton ml-2 whitespace-nowrap" onClick={onAddNewAddr}>
                                    Add New Address
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </form>
            </div>
            <ApxEditAddress show={show_new_addr_modal} 
                            data={modal_addr} 
                            error={modal_err} 
                            onNew={onSaveNewAddr} 
                            onEdit={onSaveEditAddr} 
                            onCancel={onCancelNewAddr}>
            </ApxEditAddress>
        </div>
    )
}

const Editor = (props) => {
    return (<Dashview {...props}><Content {...props}/></Dashview>);
}

export default Editor;